export const blockIconsNotificationPhoneCallback = (
	<span className='material-symbols-outlined'>phone_callback</span>
);
